module.exports = __webpack_public_path__ + "media/images/flags/tg-f97c4ebe662df8683fdec11f56c87599.svg";